import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getTransferDriverList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditTransferDriverModal from './Add_Edit/AddEditTransferDriverModal';
import DeleteTransferDriver from './Delete/DeleteTransferDriverModal';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const TransferDriversList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorTransferDrivers = createSelector(
		state => state.TransferDrivers,
		transferDriver => ({
			transferDriverList: transferDriver.transferDriverList,
			isLoadingList: transferDriver.isLoadingList,
			isTransferDriverSuccess: transferDriver.isTransferDriverSuccess,
			error: transferDriver.error,
			isAdding: transferDriver.isAdding,
			isAdded: transferDriver.isAdded,
			isAddError: transferDriver.isAddError,
			isUpdating: transferDriver.isUpdating,
			isUpdated: transferDriver.isUpdated,
			isUpdateError: transferDriver.isUpdateError,
			isDeleting: transferDriver.isDeleting,
			isDeleted: transferDriver.isDeleted,
			isDeleteError: transferDriver.isDeleteError,
		})
	);

	const { transferDriverList, isLoadingList } = useSelector(
		selectorTransferDrivers
	);

	useEffect(() => {
		dispatch(getTransferDriverList());
	}, []);

	const [dataTransferDriver, setDataTransferDriver] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete TransferDriver
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = transferDriver => {
		setDataTransferDriver(transferDriver);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = transferDriver => {
		setDataTransferDriver(transferDriver);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'transferDriver',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const transferDriverData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(transferDriverData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const transferDriverData =
														cellProps.row.original;
													handleClickDelete(transferDriverData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'RUT', accessorKey: 'rut', size: 'auto' },
			{ header: 'Nombre', accessorKey: 'name', size: 'auto' },
			{ header: 'Empresa de Transporte', accessorKey: 'transfer_company.name', size: 'auto', },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataTransferDriver({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Transportista
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={transferDriverList || []}
								isLoadingData={isLoadingList}
								nameFile={'transportista'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataTransferDriver({});
											handleToggleModal();
										},
										title: 'Crear Transportista',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditTransferDriverModal
				dataTransferDriver={dataTransferDriver}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteTransferDriver
				dataTransferDriver={dataTransferDriver}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default TransferDriversList;
